module.exports = __webpack_public_path__ + "static/media/proPic6.5b82cc8f.jpg";